import DefectDataFormatter from 'src/views/Pages/Dashboard/Quality/BoxInspection/DefectGroups/DefectDataFormatter.vue';
import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'order',
      label: i18n.t('common_words.order'),
      minWidth: 150,
      sortable: true,
      align: 'center',
      show: false,
    },
    {
      prop: 'type',
      label: i18n.t('common_words.type'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'subgroups',
      label: i18n.t('production.defects'),
      minWidth: 150,
      sortable: true,
      formatter: DefectDataFormatter,
      show: false,
    },
  ];

  return { tableColumns };
};

export default configTable;
